import './content-boxes-with-background.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';

class ContentBoxesWithBackground {
    constructor ($element) {
        this.$contentBoxesWithBackground = $element;
        this.$contentBoxesWithBackgroundSlider = this.$contentBoxesWithBackground.querySelector('[data-content-boxes-with-background="slider"]');
        this.$slides = this.$contentBoxesWithBackgroundSlider.querySelectorAll('.swiper-slide');
        this.$prevButton = null;
        this.$nextButton = null;
        this.$pagination = null;
        this.slider = null;

        this.prevSlideMessage = window.TRANSLATIONS.SLIDER.PREV_SLIDE_MESSAGE;
        this.nextSlideMessage = window.TRANSLATIONS.SLIDER.NEXT_SLIDE_MESSAGE;
        this.firstSlideMessage = window.TRANSLATIONS.SLIDER.FIRST_SLIDE_MESSAGE;
        this.lastSlideMessage = window.TRANSLATIONS.SLIDER.LAST_SLIDE_MESSAGE;
        this.slideLabel = window.TRANSLATIONS.SLIDER.SLIDE_LABEL;
        this.slideLabelFrom = window.TRANSLATIONS.SLIDER.SLIDE_LABEL_FROM;

        this.initialize();
    }

    initialize () {
        if (this.$slides.length > 1) {
            this.checkSize();
            this.setEvents();
        }
    }

    checkSize () {
        if (window.mediaMatchHandler[1024].matches) {
            this.destroySlider();
        } else {
            if (this.slider === null) {
                this.initSlider();
            }
        }
    }

    setEvents () {
        [1024, 768, 320].forEach((bp) => {
            window.mediaMatchHandler[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });
    }

    initSlider () {
        this.$prevButton = this.$contentBoxesWithBackground.querySelector('[data-slider="prev"]');
        this.$nextButton = this.$contentBoxesWithBackground.querySelector('[data-slider="next"]');
        this.$pagination = this.$contentBoxesWithBackground.querySelector('[data-slider="pagination"]');

        this.slider = new Swiper(this.$contentBoxesWithBackgroundSlider, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            slidesPerView: 'auto',
            lazyPreloadPrevNext: true,
            autoHeight: false,
            speed: 500,
            watchSlidesProgress: true,
            a11y: {
                prevSlideMessage: this.prevSlideMessage,
                nextSlideMessage: this.nextSlideMessage,
                firstSlideMessage: this.firstSlideMessage,
                lastSlideMessage: this.lastSlideMessage,
                slideLabelMessage: `${this.slideLabel} {{index}} ${this.slideLabelFrom} {{slidesLength}}`,
            },
            pagination: {
                el: this.$pagination,
                type: 'bullets',
                clickable: false
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            },
            keyboard: true,
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}

export { ContentBoxesWithBackground };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$contentBoxesWithBackgroundSlider = $context.querySelectorAll('[data-content-boxes-with-background="root"]');

    if ($$contentBoxesWithBackgroundSlider.length > 0) {
        $$contentBoxesWithBackgroundSlider.forEach(($contentBoxesWithBackgroundSlider) => {
            const contentBoxesWithBackgroundSlider = new ContentBoxesWithBackground($contentBoxesWithBackgroundSlider); // eslint-disable-line
        });
    }
});